import * as params from "./params"

export const constrainX = (xCoordinate: number, elementWidth: number): number => {
  // the xCoordinate must not be negative and the sum of xCoordinate and elementWidth must not exceed the screen width
  return Math.min(Math.max(xCoordinate, 0), params.width - elementWidth)
}

export const constrainY = (yCoordinate: number, elementHeight: number): number => {
  // the yCoordinate must not be negative and the sum of yCoordinate and elementHeight must not exceed the screen width
  return Math.min(Math.max(yCoordinate, 0), params.height - elementHeight)
}

export const constrainPosition = ({
  x,
  y,
  width,
  height,
}: {
  x: number
  width: number
  y: number
  height: number
}) => {
  return {
    x: constrainX(x, width),
    width,
    y: constrainY(y, height),
    height,
  }
}

export const convertSVGPointToScreenCoordinates = (svg: SVGSVGElement, rect: DOMRect): DOMRect => {
  const svgMatrix = svg?.getScreenCTM()
  const svgPosition = svg?.getBoundingClientRect()
  if (!svgPosition || !svgMatrix) {
    return new DOMRect(0, 0, 300, 200)
  }

  const topLeft = svg.createSVGPoint()
  topLeft.x = rect.x
  topLeft.y = rect.y
  const adjustedPoint = topLeft.matrixTransform(svgMatrix)

  const dimensions = svg.createSVGPoint()
  dimensions.x = rect.width
  dimensions.y = rect.height
  const adjustedDimensions = dimensions.matrixTransform(svgMatrix)

  return new DOMRect(
    adjustedPoint.x - svgPosition.x,
    adjustedPoint.y - svgPosition.y,
    adjustedDimensions.x - svgPosition.x,
    adjustedDimensions.y - svgPosition.y,
  )
}
